import HttpService from '../../../common/http/HttpService';
import FormEndpoint from '../const/FormEndpoint';
import FormFactory from './FormFactory';
import makeMoment from '../../../common/moment/MomentFactory';
import VcomProvider from '../../../VcomProvider';

async function listTemplates() {
  const result = await HttpService.get(FormEndpoint.TEMPLATES_BY_PARTNER);
  return result.data.map((formData) => FormFactory.make(formData));
}

async function get(formId) {
  const result = await HttpService
    .post(FormEndpoint.GET, { id: formId });
  const formData = result.data;
  return FormFactory.make(formData);
}

async function createTemplate(formTemplate) {
  const templateString = JSON.stringify(formTemplate.template);
  const data = { ...formTemplate, template: templateString };
  await HttpService.post(FormEndpoint.CREATE_TEMPLATE, data);
}

async function updateTemplate(id, template) {
  const templateString = JSON.stringify(template);
  const data = { id, template: templateString };
  await HttpService.post(FormEndpoint.UPDATE_TEMPLATE, data);
}

async function removeTemplate(id) {
  await HttpService.post(FormEndpoint.REMOVE_TEMPLATE, { id });
}

function buildLocalizedOverviewItem(form) {
  if (form.completed === null) {
    return form;
  }

  const localizedDateTime = makeMoment(form.completed)
    .utc(form.completed)
    .tz(VcomProvider.userTimeZone)
    .format('L LT');
  return { ...form, completed: localizedDateTime };
}

async function list(filters) {
  const result = await HttpService.post(FormEndpoint.LIST, { filters });
  const forms = result.data.map((formData) => FormFactory.make(formData));
  return forms.map((form) => buildLocalizedOverviewItem(form));
}

async function listByWorkOrders(workOrderIds) {
  const result = await HttpService
    .post(FormEndpoint.LIST_BY_WORK_ORDERS, { workOrderIds });
  return result.data.map((formData) => FormFactory.make(formData));
}

async function remove(form) {
  await HttpService.post(FormEndpoint.REMOVE, { id: form.id });
}

function createCheckboxField(fieldData) {
  const component = 'checkbox-field';

  const options = fieldData.options.map((option) => {
    const randomKey = Math.random().toString(36).substring(7);
    return {
      key: randomKey,
      label: option.text,
    };
  });
  const config = { options };
  return {
    title: fieldData.title,
    description: fieldData.description,
    component,
    config,
  };
}

function containsSearchTerm(form, term) {
  if (term === '') {
    return true;
  }

  const trimmedSearchTerm = term.toLowerCase().trim();

  const title = form.title === null ? '' : form.title.toLowerCase();
  const description = form.description === null ? '' : form.description.toLowerCase();

  return title.includes(trimmedSearchTerm)
    || description.includes(trimmedSearchTerm);
}

async function getVersion() {
  const { version } = await import('@meteocontrol/cmms-custom-elements/package.json');
  return version;
}

const FormService = {
  remove,
  get,
  createTemplate,
  updateTemplate,
  removeTemplate,
  list,
  listByWorkOrders,
  listTemplates,
  createCheckboxField,
  containsSearchTerm,
  getVersion,
};

export default FormService;
